<p style="font-size: 24px;margin-bottom: 25px;"><strong>Inserire criteri di filtro per navigare nel QRSP.</strong></p>

<mat-form-field class="half-width" *ngIf="tipologieCompetenze">
  <mat-label>Tipologia</mat-label>
  <mat-select [(ngModel)]="tipoCompetenza" (ngModelChange)="resetSubCategory()" name="tipologia">
    <mat-option *ngFor="let item of tipologieCompetenze" [value]="item.id">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<!-- Nuovo campo per Area, visibile solo per tipo 1 -->
<mat-form-field class="half-width" *ngIf="isCompetenzaIndipendente  && areeProfessionali">
  <mat-label>Area Professionale</mat-label>
  <mat-select [(ngModel)]="idAreaProfessionale" name="area">
    <mat-option *ngFor="let item of areeProfessionali" [value]="item.id">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field class="half-width">
  <mat-label>Competenza</mat-label>
  <!-- text input -->
  <input matInput placeholder="Profilo professionale" value="{{descrizioneCompetenza}}"
         [(ngModel)]="descrizioneCompetenza" name="descrizione">
</mat-form-field>

<!-- Add the toggle switches here -->
<div class="toggle-row">
  <div class="toggle-item">
    <p class="text-lg">Solo competenze digitali</p>
    <label class="switch">
      <input type="checkbox" [(ngModel)]="isDigital" name="toggleDigital" (change)="onDigitalToggleChange()">
      <span class="slider round"></span>
    </label>
  </div>

  <div class="toggle-item2">
    <p class="text-lg">Solo competenze green</p>
    <label class="switch">
      <input type="checkbox" [(ngModel)]="isGreen" name="toggleGreen" (change)="onGreenToggleChange()">
      <span class="slider round"></span>
    </label>
  </div>
</div>
<!-- End of toggle switches -->

<mat-form-field class="half-width" *ngIf="isCompetenzaDiBase">
  <mat-label>Sottocategoria di base</mat-label>
  <mat-select [(ngModel)]="idTipologiaCompDiBase" name="tipologia">
    <mat-option *ngFor="let item of tipologieCompetenzaDiBase" [value]="item.id">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field class="half-width" *ngIf="isDigitalSelectedType"> <!-- Renamed to avoid conflict with the new `isDigital` property -->
  <mat-label>Sottocategoria Digitale</mat-label>
  <mat-select [(ngModel)]="idTipologiaCompDigitale" name="tipologia">
    <mat-option *ngFor="let item of tipologiaCompetenzeDigitali" [value]="item.id">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<button mat-fab extended
        class="searchbox-buttons ricerca-button"
        (click)="filterSearch()"
        [disabled]="atLeastOneFilterInserted">
  <mat-icon>filter_alt</mat-icon>Filtra
</button>

<button mat-fab extended class="searchbox-buttons ripristina-button" (click)="reset()">
  <mat-icon>undo</mat-icon>Ripristina
</button>



<div style="margin-top: 130px; padding: 10px">

  <div style="padding: 50px;">
    <tile
      *ngIf="limitExceeded"
      [displayText]="warningMessageSizeExceeded"
      bgColor="yellow"
      [showWarningIcon]="true"
      [showPointer]="false"
      [showDetailIcon]="false"
    />
  </div>

  <div *ngIf="!competenze.length && fetchedContent" style="display: flex">
    <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
    <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">La ricerca non ha prodotto alcun risultato...</p>
  </div>
  <div *ngFor="let competenza of competenze;">
    <tile
      [displayText]="competenza.descrizione"
      bgColor="light-green"
      [eqfLevel]="competenza.eqfCompetenza"
      (onView)="detailCompetenza(competenza)"
      (onTileClick)="getAbilitaConoscenze(competenza)"/>


    <div [@slideInOut]="competenza.showChild ? 'in' : 'out'">

      <div *ngIf="!mapCompetenzaIdToConoscenza.get(competenza.id)?.length && competenza.quered" style="display: flex">
        <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
        <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono conoscenze da mostrare per questa competenza</p>
      </div>

      <p *ngIf="mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="margin-left: 50px; margin-top: 20px; font-size: 20px;"><strong>Conoscenze:</strong></p>

      <ul style="margin-bottom: 30px;">
        <li  *ngFor="let conoscenza of mapCompetenzaIdToConoscenza.get(competenza.id)">
          {{conoscenza.descrizione}}
        </li>
      </ul>

      <div *ngIf="!mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="display: flex; margin-top: 30px;">
        <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
        <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono abilita da mostrare per la competenza selezionata</p>
      </div>

      <p *ngIf="mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="margin-left: 50px; margin-top: 20px; font-size: 20px;"><strong>Abilità:</strong></p>

      <ul>
        <li  *ngFor="let abilita of mapCompetenzaIdToAbilita.get(competenza.id) ">
          {{abilita.descrizione}}
        </li>
      </ul>
    </div>
  </div>
</div>
